





import {Vue} from "vue-property-decorator"
const StoriesSliderBlank = Vue.extend({
    name: "StoriesSliderBlank",
});
export default StoriesSliderBlank;
